import { redirect, type LoaderFunctionArgs } from "react-router";
import {
  DOCUMENTS_PATH,
  readDocumentsTab,
  retiredContractsPath,
} from "documents/_views/pages/document-list-chips";

/**
 * `/contracts` and `/contracts/:pageTab`, which the page was until #6720: each opens the Documents
 * list that holds the rows it listed. A segment Contracts never had opens the Documents tab.
 */
export function contractsRedirectLoader({ request, params }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  return redirect(retiredContractsPath(params.pageTab, url.searchParams) ?? DOCUMENTS_PATH);
}

/**
 * `/documents/:pageTab`. Templates is the page's one segment; any other opens the Documents tab, the
 * page's own path, keeping what the link asked for.
 */
export function documentListLoader({ request, params }: LoaderFunctionArgs) {
  if (readDocumentsTab(params.pageTab) !== undefined) return null;
  const url = new URL(request.url);
  return redirect(url.search ? `${DOCUMENTS_PATH}${url.search}` : DOCUMENTS_PATH);
}
